// OIDC configuration for AWS Cognito
export const oidcConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_COGNITO_POST_LOGOUT_URI,
  response_type: 'code',
  scope: 'openid email profile',
  automaticSilentRenew: true,
  silentRequestTimeout: 10000,
  loadUserInfo: true,
  // Cognito specific metadata endpoints
  metadata: {
    issuer: process.env.REACT_APP_COGNITO_AUTHORITY,
    authorization_endpoint: `https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/oauth2/authorize`,
    token_endpoint: `https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/oauth2/token`,
    userinfo_endpoint: `https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/oauth2/userInfo`,
    end_session_endpoint: `https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/logout`,
    jwks_uri: `${process.env.REACT_APP_COGNITO_AUTHORITY}/.well-known/jwks.json`,
    check_session_iframe: null, // Cognito doesn't support session management
    revocation_endpoint: `https://${process.env.REACT_APP_COGNITO_OAUTH_DOMAIN}/oauth2/revoke`
  }
};

// Helper to check if we're in demo mode
export const isDemoMode = () => {
  return window.location.pathname.startsWith('/demo');
};